import css from 'css'
import blobToBase64 from 'blob-to-base64'

async function transformPage(originalHtmlContent, token) {

    // CREATE HTML DOCUMENT
    // THIS WILL BE USED IN FRONTEND
    const parser = new DOMParser();
    const doc = parser.parseFromString(originalHtmlContent, "text/html");
    // const doc = ((new JSDOM(originalHtmlContent)).window).document
    console.log(doc)
    // GET STYLE TAG
    const cssString = doc.querySelector('style').innerHTML.replace(/@import.*?["']([^"']+)["'].*?;/g, '')
    // console.log(cssString)

    // // PARSE CSS
    const styles = css.parse(cssString, {silent: false}).stylesheet.rules.map((r) => {

        return {
            selectors: r.selectors,
            declarations: r.declarations.map(d => {

                switch (d.property) {
                    case 'font-size':
                        return 'font-size: 12pt'
                    case 'font-family':
                        return ''
                    case 'text-indent':
                        return ''
                    default:
                        return d.property + ': ' + d.value
                }

            }).join(';')
        }
    })

    // console.log(styles)

    // START FIND ELEMENTS BY TAGNAMES CLASSES, SET STYLES, REMOVE CLASS NAMES
    styles.forEach(s => {
        s.selectors.forEach(selector => {
            try { // Sanitize or modify the selector here before applying styles
                let sanitizedSelector = sanitizeSelector(selector);

                doc.querySelectorAll(sanitizedSelector).forEach(e => {
                    let declarations = s.declarations;
                    if (selector.includes('ol.lst-kix_list_') && declarations.includes('counter-reset: lst-ctn-kix_list_')) {
                        declarations = declarations.replace('list-style-type: none', 'list-style-type: upper-latin');
                    }
                    if (e.style) {
                        e.style.cssText += declarations;
                    } else {
                        e.style = declarations;
                    }
                });
            } catch (error) {
                console.error('Error applying styles for selector:', selector);
                console.error('Error message:', error.message);
            }
        });
    });


    // Function to sanitize selectors
    function sanitizeSelector(selector) {
		return selector.replace(/[^a-zA-Z0-9-_]/g, '_');
    }


    // DOWNLOAD PICTURES FROM GOOGLE WITH AUTH

    let promises = []

    doc.querySelectorAll('img').forEach((imgEl) => {

        if (imgEl.src.includes('docs.google.com')) {

            promises.push(fetch(imgEl.src, {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + token,
                    'sec-fetch-mode': 'cors'
                }
            }).then(response => response.blob()).then(blob => new Promise((resolve, reject) => {
                if (blob.type != 'text/html') {
                    blobToBase64(blob, (error, base64) => {
                        error ? reject(error) : resolve(base64)
                    })
                } else {
                    resolve(null)
                }
            })).then((image) => {
                imgEl.src = image
            }))

        } else {
            promises.push(fetch(imgEl.src, {
                method: 'GET',
                headers: {
                    'sec-fetch-mode': 'no-cors'
                }
            }).then(response => response.blob()).then(blob => new Promise((resolve, reject) => {
                if (blob.type != 'text/html') {
                    blobToBase64(blob, (error, base64) => {
                        error ? reject(error) : resolve(base64)
                    })
                } else {
                    resolve(null)
                }
            })).then((image) => {
                imgEl.src = image
            }))
        }

    });


    await Promise.all(promises)
    const txt = doc.createElement("textarea");
    txt.innerHTML = doc.body.innerHTML;

    return txt.value
}

export default transformPage
